import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='income-annuities-intro'
    moduleName='intro-module'
    moduleVariation='A'
    disableBottomPadding={false}
    reverseContent={false}
    // content
    headingText={
      <>
        How do annuities work as part of a <WidowBlock>financial plan&#63;</WidowBlock>
      </>
    }
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='typography'>
          Whatever you dream of when it comes to retirement, making sure you&#39;ll have the money to make it happen is an important part of your financial plan. These days, fewer and fewer companies are offering pensions, and the future of Social Security is uncertain. So now, more than ever, people have to rely on themselves to plan for their finances in retirement. An annuity is one way to make sure your retirement goals stay on track, giving you a steady stream of income that doesn&#39;t change based on market volatility and is guaranteed to last the rest of your life.
        </Typography>
        <Typography
          align='left'
          nextElement='button'>
          There are different types of annuities that might be right for you depending on your goals. Income annuities are typically purchased close to retirement and give you predictable income for the rest of your life.{' '}
          <Link
            id='income-annuities-intro-fix-and-variable-link'
            linkUrl='/investments/fixed-annuity-vs-variable-annuity/'
            variant='primaryDeemphasize'
            ariaLabel='Click to learn more about fixed and variable annuities.'>
            Fixed and variable annuities
          </Link>
          {' '}can also help you grow your assets during your working years.
        </Typography>
        <Link
          id='income-annuities-product-intro-cta-fafa'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Connect with a financial advisor'>
          Connect with an advisor
        </Link>
      </>
    )}
  />

);
